/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import { CallProviderVehicleFragmentDoc } from '../../../../../ad-operator-call/src/lib/components/CallProvider/CallProvider.hook'
import { AdVehicleStreamServiceCancellationVehicleFragmentDoc } from '../../../../../ad-vehicle-stream/src/lib/ServiceCancellation/ServiceCancellation.hook'
import {
  MapAlertDrawerAdAlertFragmentDoc,
  MapAlertDrawerTaskFragmentDoc,
} from '../../../../../alert-drawer/src/lib/MapAlertDrawer.hook'
import { HereMapViewVehicleFragmentDoc } from '../../../../../fleet-maps-common/src/lib/components/HereMap/hereMapView.hook'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import {
  HasHubReturnNextFragmentDoc,
  InLocationFragmentDoc,
  IsBookableFragmentDoc,
  IsRebalancingFragmentDoc,
} from '../../../../../vehicle-common/src/lib/utils/vehicleValidators.hook'

const defaultOptions = {} as const
export type AdFleetMapVehiclesQueryVariables = Types.Exact<{
  regionId: Types.Scalars['String']['input']
  taskNotificationTypes:
    | Array<Types.TaskNotificationType>
    | Types.TaskNotificationType
  taskNotificationStatus:
    | Array<Types.TaskNotificationStatus>
    | Types.TaskNotificationStatus
  withAdAlerts: Types.Scalars['Boolean']['input']
}>

export type AdFleetMapVehiclesQuery = {
  __typename?: 'Query'
  fleetMapVehicles: {
    __typename?: 'FleetMapVehicles'
    vehicles: Array<{
      __typename?: 'Vehicle'
      id: string
      label: number | null
      inService: boolean | null
      openedBy: Types.VehicleInteractionUserType | null
      isSelfDriving: boolean
      isWheelchairAccessible: boolean | null
      totalWheelchairUsersInVehicle: number | null
      engineType: Types.VehicleEngineType | null
      highVoltageBatteryLevel: number | null
      interiorTemperature: number | null
      currentlyLocatedInHub: { __typename?: 'Hub'; id: string } | null
      taskNotifications: {
        __typename?: 'TaskNotificationList'
        tasks: Array<
          | {
              __typename: 'HubServiceNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
                backofficeUser: {
                  __typename?: 'BackofficeUser'
                  id: string
                  username: string
                } | null
              } | null
              employee: {
                __typename?: 'Employee'
                id: string
                firstName: string | null
                lastName: string | null
              } | null
              vehicle: {
                __typename?: 'Vehicle'
                totalPassengersInVehicle: number | null
                openedBy: Types.VehicleInteractionUserType | null
                id: string
                inService: boolean | null
                label: number | null
                isSelfDriving: boolean
                lastVehicleInteraction: {
                  __typename?: 'VehicleInteraction'
                  timestamp: string
                  type: Types.VehicleInteractionType
                } | null
                hardwareConfiguration: {
                  __typename?: 'HardwareConfiguration'
                  tablet: {
                    __typename?: 'Tablet'
                    phoneNumber: string | null
                  } | null
                } | null
              } | null
              shift: {
                __typename?: 'Shift'
                plannedFirstDeparture: string
                plannedLastArrival: string
              } | null
              stateChanges: Array<{
                __typename: 'TaskStateChangeDetails'
                initiatedBySystem: boolean
                timestamp: string | null
                to: Types.TaskNotificationStatus
                backofficeUser: {
                  __typename?: 'BackofficeUser'
                  username: string
                } | null
              }>
            }
          | {
              __typename?: 'IvcTaskNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'PassengerUnbuckled'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'RoadBlockageTaskNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'ShiftDeviationNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopAccessibilityDownvotedByDrivers'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopActivationFailedNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopAreaMissingActiveStopsNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopDownVotedByDrivers'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopPotentiallyUnreachable'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'StopValidationFailed'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'TimeManagementNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename: 'TripPrebookingNoAssignment'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              rejectionAt: string
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
                backofficeUser: {
                  __typename?: 'BackofficeUser'
                  id: string
                  username: string
                } | null
              } | null
              trip: {
                __typename?: 'Trip'
                id: string
                customer: {
                  __typename?: 'Customer'
                  id: string
                  firstName: string | null
                  lastName: string | null
                  phoneNumber: string | null
                } | null
                pickup: {
                  __typename?: 'TripTransferInformation'
                  promisedTime: {
                    __typename?: 'DateTimeInterval'
                    from: string
                    to: string
                  }
                }
                seatInfo: { __typename?: 'TripSeatInfo'; wheelchairs: number }
              } | null
              resolved: {
                __typename?: 'TaskStateChangeDetails'
                initiatedBySystem: boolean
              } | null
              pickupStop: {
                __typename?: 'Stop'
                id: string
                names: Partial<Record<'de' | 'en', string>>
                address: {
                  __typename?: 'StopAddress'
                  street: string | null
                  houseNumber: string | null
                  postalCode: string | null
                  city: string | null
                }
                routingLocation: {
                  __typename?: 'Location'
                  latitude: number
                  longitude: number
                }
              } | null
              dropoffStop: {
                __typename?: 'Stop'
                id: string
                names: Partial<Record<'de' | 'en', string>>
                address: {
                  __typename?: 'StopAddress'
                  street: string | null
                  houseNumber: string | null
                  postalCode: string | null
                  city: string | null
                }
                routingLocation: {
                  __typename?: 'Location'
                  latitude: number
                  longitude: number
                }
              } | null
              stateChanges: Array<{
                __typename: 'TaskStateChangeDetails'
                initiatedBySystem: boolean
                timestamp: string | null
                to: Types.TaskNotificationStatus
                backofficeUser: {
                  __typename?: 'BackofficeUser'
                  username: string
                } | null
              }>
            }
          | {
              __typename?: 'VehicleAvailabilityNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename?: 'VehicleIncidentNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
          | {
              __typename: 'VehicleSurveillanceNotification'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
                backofficeUser: {
                  __typename?: 'BackofficeUser'
                  id: string
                  username: string
                } | null
              } | null
              employee: {
                __typename?: 'Employee'
                id: string
                firstName: string | null
                lastName: string | null
              } | null
              vehicle: {
                __typename?: 'Vehicle'
                id: string
                highVoltageBatteryLevel: number | null
                cruisingRange: number | null
                totalPassengersInVehicle: number | null
                inService: boolean | null
                label: number | null
                licensePlate: string | null
                serviceAreaUUID: string
                isSelfDriving: boolean
                hardwareConfiguration: {
                  __typename?: 'HardwareConfiguration'
                  tablet: {
                    __typename?: 'Tablet'
                    phoneNumber: string | null
                  } | null
                } | null
                fleet: { __typename?: 'Fleet'; id: string } | null
                lastVehicleInteraction: {
                  __typename?: 'VehicleInteraction'
                  type: Types.VehicleInteractionType
                } | null
              } | null
              stateChanges: Array<{
                __typename: 'TaskStateChangeDetails'
                initiatedBySystem: boolean
                timestamp: string | null
                to: Types.TaskNotificationStatus
                backofficeUser: {
                  __typename?: 'BackofficeUser'
                  username: string
                } | null
              }>
            }
          | {
              __typename?: 'VehicleWaypointAttendance'
              id: string
              status: Types.TaskNotificationStatus
              severity: Types.TaskNotificationSeverity
              createdAt: string
              notificationType: Types.TaskNotificationType
              pended: {
                __typename?: 'TaskStateChangeDetails'
                timestamp: string | null
              } | null
              assigned: {
                __typename?: 'TaskStateChangeDetails'
                backofficeUserId: string | null
              } | null
            }
        >
      } | null
      fccCurrentAdAlerts: {
        __typename?: 'FccAdAlerts'
        alerts: Array<{
          __typename: 'FccAdAlert'
          id: string
          type: Types.FccAdAlertType
          status: Types.FccAdAlertStatus
          createdAt: string
          assignee: {
            __typename?: 'BackofficeUser'
            id: string
            username: string
          } | null
          vehicle: {
            __typename?: 'Vehicle'
            totalPassengersInVehicle: number | null
            id: string
            inService: boolean | null
            label: number | null
            isSelfDriving: boolean
            fccUpcomingWaypoints: Array<{
              __typename?: 'FccWaypoint'
              id: string
              actions: Array<
                | {
                    __typename: 'FccWaypointDeliveryAction'
                    id: string
                    estimatedAt: string
                    pickedUpAt: string | null
                    trip: { __typename?: 'Trip'; id: string } | null
                    customer: {
                      __typename?: 'Customer'
                      firstName: string | null
                      lastName: string | null
                      extendedWalkingTime: boolean
                      visualImpairment: boolean | null
                    } | null
                    seats: {
                      __typename?: 'FccWaypointSeatInfo'
                      seats: number
                      wheelchairs: number
                      childSeats: number
                      boosterSeats: number
                    }
                  }
                | { __typename?: 'FccWaypointHubReturnAction' }
                | {
                    __typename: 'FccWaypointPickupAction'
                    id: string
                    adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
                    tripIsCancelled: boolean | null
                    estimatedAt: string
                    pickedUpAt: string | null
                    notShownUpAt: string | null
                    trip: { __typename?: 'Trip'; id: string } | null
                    customer: {
                      __typename?: 'Customer'
                      firstName: string | null
                      lastName: string | null
                      extendedWalkingTime: boolean
                      visualImpairment: boolean | null
                    } | null
                    seats: {
                      __typename?: 'FccWaypointSeatInfo'
                      seats: number
                      wheelchairs: number
                      childSeats: number
                      boosterSeats: number
                    }
                  }
                | { __typename?: 'FccWaypointReallocationAction' }
              >
              stop: {
                __typename?: 'Stop'
                id: string
                names: Partial<Record<'de' | 'en', string>>
                serviceArea: { __typename?: 'ServiceArea'; id: string }
              } | null
            }> | null
          } | null
          statusChanges: Array<{
            __typename: 'FccAdAlertStatusChange'
            bySystem: boolean
            date: string
            to: Types.FccAdAlertStatus
            byUser: { __typename?: 'BackofficeUser'; username: string } | null
          }>
        }>
      } | null
      latestADTelemetry: {
        __typename?: 'ADTelemetry'
        centralLockLocked: {
          __typename?: 'ADTelemetryBooleanWithTimestamp'
          value: boolean
        } | null
      } | null
      nextHubReturn: {
        __typename?: 'HubReturn'
        type: Types.HubReturnType
        scheduledArrival: string
        area: { __typename?: 'Area'; id: string } | null
      } | null
      nextWaypoint: {
        __typename?: 'Waypoint'
        visible: boolean
        waypointActions: Array<{
          __typename?: 'WaypointAction'
          kind: Types.WaypointActionKind
          reallocationRadius: number | null
        }>
        stop: {
          __typename?: 'Stop'
          routingLocation: {
            __typename?: 'Location'
            latitude: number
            longitude: number
          }
        } | null
      } | null
      latestLocation: {
        __typename?: 'VehicleLocation'
        heading: number | null
        location: {
          __typename?: 'Location'
          latitude: number
          longitude: number
        } | null
      } | null
      fccUpcomingWaypoints: Array<{
        __typename?: 'FccWaypoint'
        adState: Types.FccWaypointState | null
        actions: Array<
          | {
              __typename: 'FccWaypointDeliveryAction'
              id: string
              estimatedAt: string
              pickedUpAt: string | null
              seats: {
                __typename?: 'FccWaypointSeatInfo'
                seats: number
                wheelchairs: number
                childSeats: number
                boosterSeats: number
              }
              trip: { __typename?: 'Trip'; id: string } | null
              customer: {
                __typename?: 'Customer'
                firstName: string | null
                lastName: string | null
                extendedWalkingTime: boolean
                visualImpairment: boolean | null
              } | null
            }
          | {
              __typename: 'FccWaypointHubReturnAction'
              isPlannedHubReturn: boolean
              reason: Types.FccWaypointHubReturnReason
              estimatedAt: string
            }
          | {
              __typename: 'FccWaypointPickupAction'
              id: string
              estimatedAt: string
              pickedUpAt: string | null
              adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
              notShownUpAt: string | null
              tripIsCancelled: boolean | null
              seats: {
                __typename?: 'FccWaypointSeatInfo'
                seats: number
                wheelchairs: number
                childSeats: number
                boosterSeats: number
              }
              trip: { __typename?: 'Trip'; id: string } | null
              customer: {
                __typename?: 'Customer'
                firstName: string | null
                lastName: string | null
                extendedWalkingTime: boolean
                visualImpairment: boolean | null
              } | null
            }
          | { __typename: 'FccWaypointReallocationAction'; estimatedAt: string }
        >
        stop: {
          __typename?: 'Stop'
          id: string
          names: Partial<Record<'de' | 'en', string>>
          serviceArea: { __typename?: 'ServiceArea'; id: string }
        } | null
      }> | null
      pooling: {
        __typename?: 'Pooling'
        reason: Types.PoolingReason | null
        connected: boolean | null
      } | null
      ignition: {
        __typename?: 'Ignition'
        ignitionState: Types.IgnitionState | null
        updatedAt: string | null
      } | null
    }>
  }
}

export type AdFleetMapVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  label: number | null
  inService: boolean | null
  openedBy: Types.VehicleInteractionUserType | null
  isSelfDriving: boolean
  isWheelchairAccessible: boolean | null
  totalWheelchairUsersInVehicle: number | null
  engineType: Types.VehicleEngineType | null
  highVoltageBatteryLevel: number | null
  interiorTemperature: number | null
  currentlyLocatedInHub: { __typename?: 'Hub'; id: string } | null
  taskNotifications: {
    __typename?: 'TaskNotificationList'
    tasks: Array<
      | {
          __typename: 'HubServiceNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
            backofficeUser: {
              __typename?: 'BackofficeUser'
              id: string
              username: string
            } | null
          } | null
          employee: {
            __typename?: 'Employee'
            id: string
            firstName: string | null
            lastName: string | null
          } | null
          vehicle: {
            __typename?: 'Vehicle'
            totalPassengersInVehicle: number | null
            openedBy: Types.VehicleInteractionUserType | null
            id: string
            inService: boolean | null
            label: number | null
            isSelfDriving: boolean
            lastVehicleInteraction: {
              __typename?: 'VehicleInteraction'
              timestamp: string
              type: Types.VehicleInteractionType
            } | null
            hardwareConfiguration: {
              __typename?: 'HardwareConfiguration'
              tablet: {
                __typename?: 'Tablet'
                phoneNumber: string | null
              } | null
            } | null
          } | null
          shift: {
            __typename?: 'Shift'
            plannedFirstDeparture: string
            plannedLastArrival: string
          } | null
          stateChanges: Array<{
            __typename: 'TaskStateChangeDetails'
            initiatedBySystem: boolean
            timestamp: string | null
            to: Types.TaskNotificationStatus
            backofficeUser: {
              __typename?: 'BackofficeUser'
              username: string
            } | null
          }>
        }
      | {
          __typename?: 'IvcTaskNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'PassengerUnbuckled'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'RoadBlockageTaskNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'ShiftDeviationNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopAccessibilityDownvotedByDrivers'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopActivationFailedNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopAreaMissingActiveStopsNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopDownVotedByDrivers'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopPotentiallyUnreachable'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'StopValidationFailed'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'TimeManagementNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename: 'TripPrebookingNoAssignment'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          rejectionAt: string
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
            backofficeUser: {
              __typename?: 'BackofficeUser'
              id: string
              username: string
            } | null
          } | null
          trip: {
            __typename?: 'Trip'
            id: string
            customer: {
              __typename?: 'Customer'
              id: string
              firstName: string | null
              lastName: string | null
              phoneNumber: string | null
            } | null
            pickup: {
              __typename?: 'TripTransferInformation'
              promisedTime: {
                __typename?: 'DateTimeInterval'
                from: string
                to: string
              }
            }
            seatInfo: { __typename?: 'TripSeatInfo'; wheelchairs: number }
          } | null
          resolved: {
            __typename?: 'TaskStateChangeDetails'
            initiatedBySystem: boolean
          } | null
          pickupStop: {
            __typename?: 'Stop'
            id: string
            names: Partial<Record<'de' | 'en', string>>
            address: {
              __typename?: 'StopAddress'
              street: string | null
              houseNumber: string | null
              postalCode: string | null
              city: string | null
            }
            routingLocation: {
              __typename?: 'Location'
              latitude: number
              longitude: number
            }
          } | null
          dropoffStop: {
            __typename?: 'Stop'
            id: string
            names: Partial<Record<'de' | 'en', string>>
            address: {
              __typename?: 'StopAddress'
              street: string | null
              houseNumber: string | null
              postalCode: string | null
              city: string | null
            }
            routingLocation: {
              __typename?: 'Location'
              latitude: number
              longitude: number
            }
          } | null
          stateChanges: Array<{
            __typename: 'TaskStateChangeDetails'
            initiatedBySystem: boolean
            timestamp: string | null
            to: Types.TaskNotificationStatus
            backofficeUser: {
              __typename?: 'BackofficeUser'
              username: string
            } | null
          }>
        }
      | {
          __typename?: 'VehicleAvailabilityNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename?: 'VehicleIncidentNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
      | {
          __typename: 'VehicleSurveillanceNotification'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
            backofficeUser: {
              __typename?: 'BackofficeUser'
              id: string
              username: string
            } | null
          } | null
          employee: {
            __typename?: 'Employee'
            id: string
            firstName: string | null
            lastName: string | null
          } | null
          vehicle: {
            __typename?: 'Vehicle'
            id: string
            highVoltageBatteryLevel: number | null
            cruisingRange: number | null
            totalPassengersInVehicle: number | null
            inService: boolean | null
            label: number | null
            licensePlate: string | null
            serviceAreaUUID: string
            isSelfDriving: boolean
            hardwareConfiguration: {
              __typename?: 'HardwareConfiguration'
              tablet: {
                __typename?: 'Tablet'
                phoneNumber: string | null
              } | null
            } | null
            fleet: { __typename?: 'Fleet'; id: string } | null
            lastVehicleInteraction: {
              __typename?: 'VehicleInteraction'
              type: Types.VehicleInteractionType
            } | null
          } | null
          stateChanges: Array<{
            __typename: 'TaskStateChangeDetails'
            initiatedBySystem: boolean
            timestamp: string | null
            to: Types.TaskNotificationStatus
            backofficeUser: {
              __typename?: 'BackofficeUser'
              username: string
            } | null
          }>
        }
      | {
          __typename?: 'VehicleWaypointAttendance'
          id: string
          status: Types.TaskNotificationStatus
          severity: Types.TaskNotificationSeverity
          createdAt: string
          notificationType: Types.TaskNotificationType
          pended: {
            __typename?: 'TaskStateChangeDetails'
            timestamp: string | null
          } | null
          assigned: {
            __typename?: 'TaskStateChangeDetails'
            backofficeUserId: string | null
          } | null
        }
    >
  } | null
  fccCurrentAdAlerts: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
      createdAt: string
      assignee: {
        __typename?: 'BackofficeUser'
        id: string
        username: string
      } | null
      vehicle: {
        __typename?: 'Vehicle'
        totalPassengersInVehicle: number | null
        id: string
        inService: boolean | null
        label: number | null
        isSelfDriving: boolean
        fccUpcomingWaypoints: Array<{
          __typename?: 'FccWaypoint'
          id: string
          actions: Array<
            | {
                __typename: 'FccWaypointDeliveryAction'
                id: string
                estimatedAt: string
                pickedUpAt: string | null
                trip: { __typename?: 'Trip'; id: string } | null
                customer: {
                  __typename?: 'Customer'
                  firstName: string | null
                  lastName: string | null
                  extendedWalkingTime: boolean
                  visualImpairment: boolean | null
                } | null
                seats: {
                  __typename?: 'FccWaypointSeatInfo'
                  seats: number
                  wheelchairs: number
                  childSeats: number
                  boosterSeats: number
                }
              }
            | { __typename?: 'FccWaypointHubReturnAction' }
            | {
                __typename: 'FccWaypointPickupAction'
                id: string
                adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
                tripIsCancelled: boolean | null
                estimatedAt: string
                pickedUpAt: string | null
                notShownUpAt: string | null
                trip: { __typename?: 'Trip'; id: string } | null
                customer: {
                  __typename?: 'Customer'
                  firstName: string | null
                  lastName: string | null
                  extendedWalkingTime: boolean
                  visualImpairment: boolean | null
                } | null
                seats: {
                  __typename?: 'FccWaypointSeatInfo'
                  seats: number
                  wheelchairs: number
                  childSeats: number
                  boosterSeats: number
                }
              }
            | { __typename?: 'FccWaypointReallocationAction' }
          >
          stop: {
            __typename?: 'Stop'
            id: string
            names: Partial<Record<'de' | 'en', string>>
            serviceArea: { __typename?: 'ServiceArea'; id: string }
          } | null
        }> | null
      } | null
      statusChanges: Array<{
        __typename: 'FccAdAlertStatusChange'
        bySystem: boolean
        date: string
        to: Types.FccAdAlertStatus
        byUser: { __typename?: 'BackofficeUser'; username: string } | null
      }>
    }>
  } | null
  latestADTelemetry: {
    __typename?: 'ADTelemetry'
    centralLockLocked: {
      __typename?: 'ADTelemetryBooleanWithTimestamp'
      value: boolean
    } | null
  } | null
  nextHubReturn: {
    __typename?: 'HubReturn'
    type: Types.HubReturnType
    scheduledArrival: string
    area: { __typename?: 'Area'; id: string } | null
  } | null
  nextWaypoint: {
    __typename?: 'Waypoint'
    visible: boolean
    waypointActions: Array<{
      __typename?: 'WaypointAction'
      kind: Types.WaypointActionKind
      reallocationRadius: number | null
    }>
    stop: {
      __typename?: 'Stop'
      routingLocation: {
        __typename?: 'Location'
        latitude: number
        longitude: number
      }
    } | null
  } | null
  latestLocation: {
    __typename?: 'VehicleLocation'
    heading: number | null
    location: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    } | null
  } | null
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    adState: Types.FccWaypointState | null
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          seats: {
            __typename?: 'FccWaypointSeatInfo'
            seats: number
            wheelchairs: number
            childSeats: number
            boosterSeats: number
          }
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
        }
      | {
          __typename: 'FccWaypointHubReturnAction'
          isPlannedHubReturn: boolean
          reason: Types.FccWaypointHubReturnReason
          estimatedAt: string
        }
      | {
          __typename: 'FccWaypointPickupAction'
          id: string
          estimatedAt: string
          pickedUpAt: string | null
          adPassengerAuthenticationState: Types.FccPassengerAuthenticationState | null
          notShownUpAt: string | null
          tripIsCancelled: boolean | null
          seats: {
            __typename?: 'FccWaypointSeatInfo'
            seats: number
            wheelchairs: number
            childSeats: number
            boosterSeats: number
          }
          trip: { __typename?: 'Trip'; id: string } | null
          customer: {
            __typename?: 'Customer'
            firstName: string | null
            lastName: string | null
            extendedWalkingTime: boolean
            visualImpairment: boolean | null
          } | null
        }
      | { __typename: 'FccWaypointReallocationAction'; estimatedAt: string }
    >
    stop: {
      __typename?: 'Stop'
      id: string
      names: Partial<Record<'de' | 'en', string>>
      serviceArea: { __typename?: 'ServiceArea'; id: string }
    } | null
  }> | null
  pooling: {
    __typename?: 'Pooling'
    reason: Types.PoolingReason | null
    connected: boolean | null
  } | null
  ignition: {
    __typename?: 'Ignition'
    ignitionState: Types.IgnitionState | null
    updatedAt: string | null
  } | null
}

export const AdFleetMapVehicleFragmentDoc = gql`
    fragment AdFleetMapVehicle on Vehicle {
  id
  label
  currentlyLocatedInHub {
    id
  }
  ...IsBookable
  ...InLocation
  ...HasHubReturnNext
  ...IsRebalancing
  ...HereMapViewVehicle
  ...CallProviderVehicle
  ...AdVehicleStreamServiceCancellationVehicle
  taskNotifications(
    types: $taskNotificationTypes
    status: $taskNotificationStatus
  ) {
    tasks {
      id
      status
      severity
      ...MapAlertDrawerTask
    }
  }
  fccCurrentAdAlerts {
    alerts {
      ...MapAlertDrawerAdAlert
    }
  }
  latestADTelemetry {
    centralLockLocked {
      value
    }
  }
}
    ${IsBookableFragmentDoc}
${InLocationFragmentDoc}
${HasHubReturnNextFragmentDoc}
${IsRebalancingFragmentDoc}
${HereMapViewVehicleFragmentDoc}
${CallProviderVehicleFragmentDoc}
${AdVehicleStreamServiceCancellationVehicleFragmentDoc}
${MapAlertDrawerTaskFragmentDoc}
${MapAlertDrawerAdAlertFragmentDoc}`
export const AdFleetMapVehiclesDocument = gql`
    query AdFleetMapVehicles($regionId: String!, $taskNotificationTypes: [TaskNotificationType!]!, $taskNotificationStatus: [TaskNotificationStatus!]!, $withAdAlerts: Boolean!) {
  fleetMapVehicles(input: {regionId: $regionId, isSelfDriving: true}) {
    vehicles {
      ...AdFleetMapVehicle
    }
  }
}
    ${AdFleetMapVehicleFragmentDoc}`

/**
 * __useAdFleetMapVehiclesQuery__
 *
 * To run a query within a React component, call `useAdFleetMapVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdFleetMapVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdFleetMapVehiclesQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      taskNotificationTypes: // value for 'taskNotificationTypes'
 *      taskNotificationStatus: // value for 'taskNotificationStatus'
 *      withAdAlerts: // value for 'withAdAlerts'
 *   },
 * });
 */
export function useAdFleetMapVehiclesQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdFleetMapVehiclesQuery,
    AdFleetMapVehiclesQueryVariables
  > &
    (
      | { variables: AdFleetMapVehiclesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AdFleetMapVehiclesQuery,
    AdFleetMapVehiclesQueryVariables
  >(AdFleetMapVehiclesDocument, options)
}
export function useAdFleetMapVehiclesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdFleetMapVehiclesQuery,
    AdFleetMapVehiclesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AdFleetMapVehiclesQuery,
    AdFleetMapVehiclesQueryVariables
  >(AdFleetMapVehiclesDocument, options)
}
export function useAdFleetMapVehiclesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AdFleetMapVehiclesQuery,
        AdFleetMapVehiclesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AdFleetMapVehiclesQuery,
    AdFleetMapVehiclesQueryVariables
  >(AdFleetMapVehiclesDocument, options)
}
export type AdFleetMapVehiclesQueryHookResult = ReturnType<
  typeof useAdFleetMapVehiclesQuery
>
export type AdFleetMapVehiclesLazyQueryHookResult = ReturnType<
  typeof useAdFleetMapVehiclesLazyQuery
>
export type AdFleetMapVehiclesSuspenseQueryHookResult = ReturnType<
  typeof useAdFleetMapVehiclesSuspenseQuery
>
export type AdFleetMapVehiclesQueryResult = Apollo.QueryResult<
  AdFleetMapVehiclesQuery,
  AdFleetMapVehiclesQueryVariables
>
